<template>
  <div>
    <div v-if="commentsLines.length > 1">
      <span
        class="d-block mb-2"
        v-for="(line, index) in commentsLines"
        :key="index"
      >
        {{ line }}
      </span>
    </div>
    <span v-else>No Comments</span>
  </div>
</template>

<script>
import Vue from "vue";
import * as types from "../store/types";
import { mapGetters } from "vuex";

export default Vue.extend({
  data() {
    return {
      commentsLines: [],
    };
  },

  computed: {
    ...mapGetters({
      application: types.APPLICATION,
      saving: types.SAVING_FORM,
    }),
  },

  methods: {
    updateCommentLines() {
      this.commentsLines = this.application.comments.split("\n");
    },
  },

  watch: {
    application: {
      immediate: true,
      handler() {
        setTimeout(() => this.updateCommentLines(), 500);
      },
    },
  },
});
</script>
